import { all, fork } from "redux-saga/effects";
import authShopSaga from "./authShopSaga";
import orderSaga from "./orderSaga"

const rootSaga = function* () {
  yield all([
    fork(authShopSaga),
    fork(orderSaga),
    // Other forks
  ]);
};

export default rootSaga;